(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fc-travel-property"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fc-travel-property')) {
  class FCTravelProperty extends HTMLElement {
    connectedCallback() {
      // Theme editor insertion can connect an element before its children finish parsing.
      requestAnimationFrame(() => { if (this.isConnected) this.initialize(); });
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.restoreScroll();
      this.controller?.abort();
      this.ready = false;
    }
    initialize() {
      if (this.ready) return;
      this.ready = true;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      const tablist = this.querySelector('[data-tabs]');
      if (tablist && this.tabs.length) {
        tablist.setAttribute('role', 'tablist');
        this.tabs.forEach((tab, index) => {
          const panel = this.panels[index];
          if (!panel) return;
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', panel.id);
          panel.setAttribute('role', 'tabpanel');
          tab.addEventListener('click', event => {
            event.preventDefault(); this.selectTab(index, true);
          }, options);
          tab.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (event.key === ' ') { event.preventDefault(); this.selectTab(index, true); return; }
            if (next !== undefined) { event.preventDefault(); this.selectTab(next, true); }
          }, options);
        });
        const initial = this.panels.findIndex(panel => '#' + panel.id === window.location.hash);
        this.selectTab(initial >= 0 ? initial : 0, false);
        window.addEventListener('hashchange', () => {
          const index = this.panels.findIndex(panel => '#' + panel.id === window.location.hash);
          if (index >= 0) this.selectTab(index, false);
        }, options);
      }
      this.classList.add('is-ready');
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const id = String(event.detail?.blockId || '');
        const index = this.tabs.findIndex(tab => tab.dataset.blockId === id);
        if (index >= 0) this.selectTab(index, false);
      }, options);
      const more = this.querySelector('[data-gallery-more]');
      if (more) {
        more.hidden = false;
        more.addEventListener('click', () => {
          this.classList.add('gallery-expanded'); more.hidden = true;
          this.querySelector('.fct-gallery-extra')?.focus();
        }, options);
      }
      this.images = Array.from(this.querySelectorAll('[data-gallery-image]'));
      this.dialog = this.querySelector('[data-lightbox]');
      if (this.dialog && typeof this.dialog.showModal === 'function') {
        this.images.forEach((link, index) => link.addEventListener('click', event => {
          event.preventDefault(); this.galleryReturn = link; this.showPhoto(index);
          this.previousOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          this.dialog.showModal();
          this.querySelector('[data-lightbox-close]')?.focus();
        }, options));
        this.querySelector('[data-lightbox-close]').addEventListener('click', () => this.dialog.close(), options);
        this.querySelector('[data-lightbox-prev]').addEventListener('click', () => this.showPhoto(this.photoIndex - 1), options);
        this.querySelector('[data-lightbox-next]').addEventListener('click', () => this.showPhoto(this.photoIndex + 1), options);
        this.dialog.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft') { event.preventDefault(); this.showPhoto(this.photoIndex - 1); }
          if (event.key === 'ArrowRight') { event.preventDefault(); this.showPhoto(this.photoIndex + 1); }
        }, options);
        this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); }, options);
        this.dialog.addEventListener('close', () => { this.restoreScroll(); this.galleryReturn?.focus({ preventScroll: true }); }, options);
      }
      const status = this.querySelector('[data-form-status]');
      if (status) { status.focus({ preventScroll: true }); status.scrollIntoView({ block: 'center' }); }
    }
    selectTab(index, focus) {
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        if (this.panels[i]) this.panels[i].hidden = i !== index;
      });
      if (focus && this.tabs[index]) {
        const tab = this.tabs[index];
        tab.focus({ preventScroll: true });
        // Scroll only the horizontal tab row; do not jump the whole page.
        const parent = tab.parentElement;
        const left = parent.scrollLeft + tab.getBoundingClientRect().left - parent.getBoundingClientRect().left - (parent.clientWidth - tab.offsetWidth) / 2;
        parent.scrollTo({ left, behavior: 'auto' });
      }
    }
    restoreScroll() {
      if (this.previousOverflow !== undefined) {
        document.documentElement.style.overflow = this.previousOverflow;
        this.previousOverflow = undefined;
      }
    }
    showPhoto(index) {
      if (!this.images.length) return;
      this.photoIndex = (index + this.images.length) % this.images.length;
      const link = this.images[this.photoIndex];
      const image = this.querySelector('[data-lightbox-image]');
      image.src = link.href;
      image.alt = link.dataset.caption || '';
      this.querySelector('[data-lightbox-caption]').textContent = `${this.photoIndex + 1} / ${this.images.length}  ${image.alt}`;
    }
  }
  customElements.define('fc-travel-property', FCTravelProperty);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
